"use client";

import { type ComponentProps, memo } from "react";
import { Streamdown } from "streamdown";
import { cn } from "@/lib/utils";
// Import the reasoning components
import { Reasoning, ReasoningTrigger, ReasoningContent } from "./reasoning";

type ResponseProps = ComponentProps<typeof Streamdown>;

export const Response = memo(
 ({ className, ...props }: ResponseProps) => (
 <Streamdown
 className={cn(
 "size-full [&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
 className
 )}
 components={{
    // FIX: Render paragraphs as divs to allow nested block elements 
    // (like tool results or reasoning boxes)
    p: ({ children }) => <div className="mb-4 last:mb-0">{children}</div>,

    reasoning: ({ children }: { children: string }) => (
      <Reasoning className="my-2 border rounded-lg bg-slate-50/50 p-2 shadow-sm">
        <ReasoningTrigger />
        <ReasoningContent>{children}</ReasoningContent>
      </Reasoning>
    ),
 }}
 {...props}
 />
 ),
 (prevProps, nextProps) => prevProps.children === nextProps.children
);


Response.displayName = "Response";
